import { render, staticRenderFns } from "./QuoteOfTheDay.vue?vue&type=template&id=7462ce80&"
import script from "./QuoteOfTheDay.vue?vue&type=script&lang=js&"
export * from "./QuoteOfTheDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports